import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './Payment.css'; // Custom CSS
import NavBar from "../../Components/NavBar/NavBar";
import Faqs from "../../Components/FAQs/FAQs";
import Footer from "../../Components/Footer/Footer"; 
import useAuth from "../../Components/Hooks/UseAuth";

import { useNavigate } from 'react-router-dom'; // Use useNavigate
import ScrollToTop from "../../Components/ScrollTop/ScroolTop";

const PaymentSection = ({ handleClose }) => {
  const { auth } = useAuth();
  const navigate = useNavigate(); // Initialize navigate for navigation

  const handleOnlinePayment = () => {
    navigate('/indopay'); // Redirect to the student number entry page
  };

  return (
    <>
      <ScrollToTop />
      <NavBar />
      <div className="payment-container">
        {/* Heading */}
        <h1 className="payment-heading">Payment Methods</h1>

        {/* Introductory Text */}
        <p className="payment-intro">
          Explore the various payment methods available for your course fees. Please follow the instructions provided for each method.
        </p>

        {/* Payment Methods Section */}
        <div className="payment-methods">

          {/* Online Payment Section */}
          <div className="payment-method online-payment">
            <h3 className="method-title">Online Payment</h3>
            <div className="method-details">
              <p>
                To pay your fees online, click the button below. You will be redirected to enter your student number and proceed with the payment.
              </p>
              <button className="pay-online-button" onClick={handleOnlinePayment}>
                Pay Online
              </button>
            </div>
          </div>

          {/* Banks Section */}
          <div className="payment-method">
            <h3 className="method-title">Banks</h3>
            <div className="method-details">
              <h4>Zanaco Billmuster</h4>
              <ol>
                <li>Visit a Zanaco Billmuster authorized branch or booth.</li>
                <li>Your student ID (<b>{auth?.UserID}</b>) is required for payment processing.</li>
              </ol>
            </div>
          </div>

          {/* Mobile Money Section */}
          <div className="payment-method">
            <h3 className="method-title">Mobile Money</h3>
            <div className="method-details">
              <h4>Airtel Money Billmuster</h4>
              <ol>
                <li>Dial *115#.</li>
                <li>Select Option 4 (Make Payment).</li>
                <li>Select Option 7 (School Fees).</li>
                <li>Select Option 3 (Zanaco Billmuster).</li>
                <li>Select Option 1 (University).</li>
                <li>Select Option 4 (Unilus).</li>
                <li>Select Option 1 (Unilus).</li>
                <li>Enter your student number <b>{auth?.UserID ? `: ${auth?.UserID}` : ""}</b></li>
              </ol>
            </div>
          </div>

          

        </div>

        {/* Footer */}
        <div className="payment-footer">
          <p>Secure your spot now! Full payment must be completed before the start date.</p>
        </div>

        {/* Close Button */}
        {/* <div className="close-button" onClick={handleClose}>
          Close [<FontAwesomeIcon className="fontawesomIconsClose" icon={faTimes} />]
        </div> */}
      </div>
      
      <Faqs />
      <Footer />
    </>
  );
};

export default PaymentSection;


// import React from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import './Payment.css'; // Custom CSS
// import NavBar from "../../Components/NavBar/NavBar";
// import Faqs from "../../Components/FAQs/FAQs";
// import Footer from "../../Components/Footer/Footer"; 
// import useAuth from "../../Components/Hooks/UseAuth";
// import ScrollToTop from "../../Components/ScrollTop/ScroolTop";

// const PaymentSection = ({  handleClose }) => {

//   const {auth,setauth} = useAuth()
//   return (
//     <>

//     <ScrollToTop/>
//     <NavBar/>
//     <div className="payment-container">
//       {/* Heading */}
//       <h1 className="payment-heading">Payment Methods</h1>

//       {/* Introductory Text */}
//       <p className="payment-intro">
//         Below are instructions on the various methods of payment available for your course fees.
//         Please make sure to follow the steps provided for each method.
//       </p>

//       {/* Banks Section */}
//       <h2>Banks</h2>
//       <div className="payment-method">
//         <h3>Zanaco Billmuster</h3>
//         <h4>Steps</h4>
//         <ol>
//           <li>Go to the nearest Zanaco Billmuster authorized branch or booth.</li>
//           <li>Your student ID (<b>{auth?.UserID}</b>) is required to process the payment.</li>
//         </ol>
//       </div>

//       {/* Mobile Money Section */}
//       <h2>Mobile Money</h2>
//       <div className="payment-method">
//         <h3>Airtel Money Billmuster</h3>
//         <h4>Steps</h4>
//         <ol>
//           <li>Dial *115#.</li>
//           <li>Select Option 4 (Make Payment).</li>
//           <li>Select Option 7 (School Fees).</li>
//           <li>Select Option 3 (Zanaco Billmuster).</li>
//           <li>Select Option 1 (University).</li>
//           <li>Select Option 4 (Unilus).</li>
//           <li>Select Option 1 (Unilus).</li>
//           <li>Enter your student number <b>{auth?.UserID? `: ${auth?.UserID}` : ""}</b></li>
//         </ol>
//       </div>

//       {/* Footer */}
//       <div className="payment-footer">
//         <p>Secure your spot now! Full payment must be completed before the start date.</p>
//       </div>

//       {/* Close Button */}
//       {/* <div className="close-button" onClick={handleClose}>
//         Close [<FontAwesomeIcon className="fontawesomIconsClose" icon={faTimes} />]
//       </div> */}
//     </div>
      
//       <Faqs/>
//       <Footer/>
//     </>
//   );
// };

// export default PaymentSection;
